const getInbetweenNumbers = (num1, num2) => {
  let result = [];
  for (let i = num1; i <= num2; i++) {
    result.push(i);
  }
  return result;
}

export const SURVEY_YEARS = getInbetweenNumbers(2000, 2023);

export const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

export const darkColor = '#25262B';

export const homeLineData = [
  { x: 0, y: 32, ind: 1 },
  { x: 10, y: 38, ind: 1 },
  { x: 20, y: 45, ind: 1 },
  { x: 30, y: 43, ind: 1 },
  { x: 40, y: 45, ind: 1 },
  { x: 50, y: 43.5, ind: 1 },
  { x: 60, y: 47, ind: 1 },
  { x: 70, y: 55, ind: 1 },
  { x: 80, y: 53, ind: 1 },
  { x: 90, y: 55, ind: 1 },
  { x: 100, y: 75, ind: 1 },
  { x: 0, y: 8, ind: 2 },
  { x: 10, y: 10, ind: 2 },
  { x: 20, y: 11, ind: 2 },
  { x: 30, y: 12, ind: 2 },
  { x: 40, y: 25, ind: 2 },
  { x: 50, y: 32, ind: 2 },
  { x: 60, y: 30, ind: 2 },
  { x: 70, y: 29, ind: 2 },
  { x: 80, y: 35, ind: 2 },
  { x: 90, y: 45, ind: 2 },
  { x: 100, y: 55, ind: 2 },
  { x: 0, y: 0, ind: 3 },
  { x: 10, y: 1, ind: 3 },
  { x: 20, y: 5, ind: 3 },
  { x: 30, y: 4, ind: 3 },
  { x: 40, y: 2, ind: 3 },
  { x: 50, y: 10, ind: 3 },
  { x: 60, y: 18, ind: 3 },
  { x: 70, y: 15, ind: 3 },
  { x: 80, y: 23, ind: 3 },
  { x: 90, y: 35, ind: 3 },
  { x: 100, y: 38, ind: 3 },
]

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};


const passwordRequirements = [
  { re: /[0-9]/, label: 'Includes number' },
  { re: /[a-z]/, label: 'Includes lowercase letter' },
  { re: /[A-Z]/, label: 'Includes uppercase letter' },
];

export const validatePassword = (password) => {
  if (password.length < 8) return 'Password must be at least 8 characters long';
  if (!passwordRequirements.every((req) => req.re.test(password))) return 'Password must include at least one number, one lowercase letter and one uppercase letter';
  return null;
}

export const examples = [
  { value: 'f507f46c8042264fd2f07283fcc8e9382fa9e64b', label: `What's your gender?`, group: 'Demographic alignment', url: 'localhost' },
  { value: 'baa3d5f25236b91f1608c9f606b315ac8e8c2532', label: 'Gender', group: 'Demographic alignment', url: 'app.roundtable.ai' },
  { value: '4731741d125cf8c996c03e433125d541b2f514be', label: 'Labor force participation', group: 'Demographic alignment', url: 'localhost' },
  { value: '7a9ee27872eb29087be2386ccd19f7ec1a5ad5fe', label: 'Labor force participation', group: 'Demographic alignment', url: 'app.roundtable.ai' },
  { value: 'ccef2d51748821aa258c8e6dddd290d85c5a1d50', label: 'Age', group: 'Demographic alignment', url: 'localhost' },
  { value: '88a44a356e94c0808c1976e36258e8cf24b40fac', label: 'Age', group: 'Demographic alignment', url: 'app.roundtable.ai' },
  { value: 'fc8e7a2590b90bf5f9dfabc4caa8b40bd2c705fd', label: 'Race/ethnicity', group: 'Demographic alignment', url: 'localhost' },
  { value: 'a85d3a3759dadb1fcf490195fbfac511a56e5837', label: 'Race/ethnicity', group: 'Demographic alignment', url: 'app.roundtable.ai' },
  { value: '3c30139b0786425610611c0ff41e5976eb95461a', label: 'Product interest ranking', group: 'Surveys', url: 'localhost' },
  { value: '08a68c4ad3674f2ae331a4f09f03745e56293db2', label: 'Product interest ranking', group: 'Surveys', url: 'app.roundtable.ai' },
  { value: '26f17299e68c23fa8808b6ee2aa28bda89217eff', label: 'Willingness to pay', group: 'Surveys', url: 'app.roundtable.ai' },
  { value: 'e556d78199cd3564f69a9828d166fa058fa401e9', label: 'Shopping habits and behaviors', group: 'Surveys', url: 'localhost' },
  { value: 'd777e3996d5f2565a238c30feaed0bf33ede12ef', label: 'Shopping habits and behaviors', group: 'Surveys', url: 'app.roundtable.ai' },
  { value: 'd53df0466e3993eddf8750d986fe3f6c78b9d058', label: 'Brand/product naming', group: 'Surveys', url: 'localhost' },
  { value: '166b24e8cd871333a859264964f5f1c097f5d092', label: 'Brand/product naming', group: 'Surveys', url: 'app.roundtable.ai' },
  { value: '948894ee3f05814343b5e0ab20dc53837749b49a', label: 'Product feature importance', group: 'Surveys', url: 'localhost' },
  { value: '0450d499048c089894c34fba514db4042eafb6c0', label: 'Product feature importance', group: 'Surveys', url: 'app.roundtable.ai' },
  { value: '580087c0b3ac58f0b9702a830202299ccb2d0cb3', label: 'Public opinion', group: 'Surveys', url: 'app.roundtable.ai' },
  { value: '7bc4790bf850ec9d1bd94aeac43763294c130e1a', label: 'Ethical product importance', group: 'Panel surveys', url: 'localhost' },
  { value: '18d5c40f647ede9acc4b29642d976ac311f318ec', label: 'Ethical product importance', group: 'Panel surveys', url: 'app.roundtable.ai' },
  { value: '596611aef1e8de41368981a4690e733f2017cf2e', label: 'Consumption patterns', group: 'Panel surveys', url: 'app.roundtable.ai' },
  { value: '5ea1ab7813ea78cb949df3f74dce7a8e54102441', label: 'Presidential approval', group: 'Panel surveys', url: 'app.roundtable.ai' },
];

export const objectsAreEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export const tooltipTextStyles = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
}

export const computerNumberStyles = {
  fontFamily: 'Monaco, monospace',
  lineHeight: '100%',
  backgroundColor: '#f0f0f0',
  padding: '.2em',
  letterSpacing: '-.05em',
  wordBreak: 'normal',
}

export const getTooltipProportionText = (proportion, plotType) => {
  if (plotType === 'dashboard') return proportion;
  // If proportion isn't a number, return empty string
  if (isNaN(proportion)) return '';
  if (proportion >= 0.995) return `>0.99`;
  if (proportion <= 0.005) return `<0.01`;
  return `${proportion.toFixed(2)}`;
}

export const grayColor = '#4f4f4f';
export const lightBoxShadowNonHover = '5px 5px 10px 0 rgba(0, 0, 0, 0.1)'
export const lightBoxShadowHover = '0px 0px 10px 0 rgba(0, 0, 0, 0.2)'

export const nonHoverBoxShadow = '7px 7px 10px 0 rgba(0, 0, 0, 0.25)'
export const hoverBoxShadow = '7px 7px 10px 0 rgba(0, 0, 0, 0.4)';

export const pricingInfo = [
  { numCredits: 100, price: 20 },
  { numCredits: 1000, price: 190 },
  { numCredits: 10000, price: 1700 },
];

export const isEmpty = (obj) => Object.keys(obj).length === 0;

// This is for safari as it doesn't take rem units for rx/ry values for svg rects
export const remToPx = (remString) => {
  const rem = parseFloat(remString);
  const style = window.getComputedStyle ? getComputedStyle(document.documentElement) : null;
  const fontSize = style ? parseFloat(style.fontSize) : 16;
  return rem * fontSize;
}

export const getCopyLink = (dataDict, url) => {
  // If data dict is empty return empty string
  if (Object.keys(dataDict).length === 0) {
    return url;
  }
  // Else return link with data dict
  return `${url}/${dataDict.id}`;
}

export const requireAccountToAccessSandbox = true;


const prepareDataForJSONDownload = (inputData) => {
  const {
    isPanel,
    surveyCountry,
    surveyQuestion,
    surveyAnswers,
    customQuestionsAndResponses,
    surveyDescriptions,
    surveyData,
    surveyModel,
    product
  } = inputData;
  //  Loop through surveyData and remove rawResponses from each entry
  const formattedSurveyData = surveyData.map(entry => {
    const { responses } = entry;
    return responses;
  });
  let relevantData = { surveyCountry, surveyQuestion, surveyAnswers, customQuestionsAndResponses, surveyDescriptions, surveyData: formattedSurveyData };
  if (surveyModel.includes('GSS')) {
    relevantData = { isPanel, ...relevantData, surveyModel };
  } else {
    const productStr = product.length > 0 ? product : 'none';
    relevantData = { ...relevantData, surveyModel, surveyProduct: productStr };
  }
  const stringifiedData = JSON.stringify(relevantData);
  return stringifiedData;
}

const downloadString = (string, filename) => {
  const a = document.createElement("a");
  const file = new Blob([string], { type: 'text/plain' });
  a.href = URL.createObjectURL(file);
  a.download = filename;
  a.click();
}

export const downloadCSV = (array) => {

  // Check if year exists in array[0]
  const yearString = array[0].hasOwnProperty('year') ? 'year,' : '';

  let csv = `${yearString}response,proportion\n`;

  // Iterate through the array
  for (const obj of array) {

    csv += Object.entries(obj.responses)
      .map(([key, value]) => {
        return yearString == '' ? `${key},${value}\n` : `${obj.year},${key},${value}\n`;
      })
      .join('');

  }

  downloadString(csv, 'data.csv');
}

export const downloadJSON = (dataObjList) => {
  if (dataObjList === undefined || !Array.isArray(dataObjList)) return;

  const preparedDataList = dataObjList.map(dataObj => {
    if (dataObj && JSON.stringify(dataObj) !== '{}') {
      return prepareDataForJSONDownload(dataObj);
    }
  }).filter(Boolean);

  if (preparedDataList.length > 0) {
    const formattedData = JSON.stringify(preparedDataList);
    downloadString(formattedData, 'data.json');
  }
}

export const beigeColor = '#F9F9F7';


export const homepageSurveyAnimations = [

];

export const shortenedFlags = {
  'None': 'No flags',
  'Automated test: Gibberish': 'Gibberish',
  'Automated test: Off-topic': 'Off-topic',
  'Automated test: Low-effort': 'Low-effort',
  'Automated test: Junk': 'Junk',
  'Automated test: GPT': 'GPT',
  'GPT paste artifacts': 'GPT artifacts',
  'Text chunking': 'Text chunking',
  'Unnatural typing speed': 'Typing speed',
  'Unnatural pausing': 'Pausing',
  'Response pasted': 'Pasted',
  'Self-duplicate response': 'Self-duplicate',
  'Cross-duplicate response': 'Duplicate',
  'Programmatic entry': 'Programmatic',
  'All responses empty': 'All empty',
}

export const flagsForModel = {
  'alias-v01': [
    'Automated test: Junk',
    'Automated test: GPT',
    'GPT paste artifacts',
    'Text chunking',
    'Unnatural typing speed',
    'Unnatural pausing',
    'Self-duplicate response',
    'Cross-duplicate response',
    'All responses empty',
  ],
  'alias-v011': [
    'Automated test: Junk',
    'Automated test: GPT',
    'GPT paste artifacts',
    'Text chunking',
    'Unnatural typing speed',
    'Unnatural pausing',
    'Self-duplicate response',
    'Cross-duplicate response',
    'All responses empty',
  ],
  'alias-v012': [
    'Automated test: Junk',
    'Automated test: GPT',
    'GPT paste artifacts',
    'Text chunking',
    'Unnatural typing speed',
    'Self-duplicate response',
    'Cross-duplicate response',
  ],
  'alias-v013': [,
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: Low-effort',
    'Automated test: GPT',
    'GPT paste artifacts',
    'Response pasted',
    'Self-duplicate response',
    'Cross-duplicate response',
  ],
  'alias-v014': [,
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: Low-effort',
    'Automated test: GPT',
    'GPT paste artifacts',
    'Response pasted',
    'Programmatic entry',
    'Self-duplicate response',
    'Cross-duplicate response',
  ],
  'alias-v015': [,
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: GPT',
    'Low-effort',
    'Response pasted',
    'Programmatic entry',
    'Unnatural typing',
    'Self-duplicate response',
    'Cross-duplicate response',
    'GPT paste artifacts',
  ],
  'alias-v016': [,
    'Automated test: Profane',
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: GPT',
    'Low-effort',
    'Response pasted',
    'Programmatic entry',
    'Unnatural typing',
    'Self-duplicate response',
    'Cross-duplicate response',
    'GPT paste artifacts',
  ],
  'alias-v017': [,
    'Automated test: Profane',
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: GPT',
    'Low-effort',
    'Response pasted',
    'Partial pasting',
    'Programmatic entry',
    'Unnatural typing',
    'Self-duplicate response',
    'Cross-duplicate response',
  ],
  'alias-v020': [,
    'Automated test: Profane',
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: GPT',
    'Low-effort',
    'Response pasted',
    'Partial pasting',
    'Programmatic entry',
    'Unnatural typing',
    'Self-duplicate response',
    'Cross-duplicate response',
  ],
  'alias-v021': [,
    'Automated test: Profane',
    'Automated test: Gibberish',
    'Automated test: Off-topic',
    'Automated test: GPT',
    'Low-effort',
    'Response pasted',
    'Partial pasting',
    'Programmatic entry',
    'Unnatural typing',
    'Self-duplicate response',
    'Cross-duplicate response',
  ]
};

export const prepareChartDataFromCache = (rawHistory) => {
  if (rawHistory.length === 0) return;
  rawHistory[0].time_since_start = 0;
  const data = rawHistory.map((item, index) => ({
    index: index,
    keystroke_time: index === 0 ? 0 : item.time_since_start - rawHistory[index - 1].time_since_start
  }));
  if (data.length === 1) return data;
  return data.slice(1, 200);
};

export const addCommasToNumber = (num) => {
  num = parseFloat(num);
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const demoData = {
  "High-Quality Response": {
    "question": "How do you choose a shampoo to buy?",
    "response": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially good.",
    "result": {
      "flagged": false,
      "flags": "No flags",
      "effort_rating": 6,
    },
    "fingerprint_checks": {
      "ip":"192.168.1.57",
      "city":"San Francisco",
      "geolocation":{"latitude":37.7833,"longitude":-122.4952},
      "browser":"Chrome 129.0.0",
      "vpn":false,
      "incognito":false,
      "device_id":"3pzig2Tu5GtqHY1Kh1p3"
    },
    "questionHistory": [
      {
        "s": "I",
        "t": 1718997431401
      },
      {
        "s": "I ",
        "t": 207
      },
      {
        "s": "I g",
        "t": 313
      },
      {
        "s": "I ge",
        "t": 607
      },
      {
        "s": "I gen",
        "t": 780
      },
      {
        "s": "I gene",
        "t": 841
      },
      {
        "s": "I gener",
        "t": 927
      },
      {
        "s": "I genera",
        "t": 1117
      },
      {
        "s": "I general",
        "t": 1245
      },
      {
        "s": "I generally",
        "t": 1396
      },
      {
        "s": "I generally ",
        "t": 1498
      },
      {
        "s": "I generally j",
        "t": 1630
      },
      {
        "s": "I generally ju",
        "t": 1921
      },
      {
        "s": "I generally jus",
        "t": 2125
      },
      {
        "s": "I generally just",
        "t": 2288
      },
      {
        "s": "I generally just ",
        "t": 2373
      },
      {
        "s": "I generally just b",
        "t": 2430
      },
      {
        "s": "I generally just bu",
        "t": 2602
      },
      {
        "s": "I generally just buy",
        "t": 2690
      },
      {
        "s": "I generally just buy ",
        "t": 2779
      },
      {
        "s": "I generally just buy w",
        "t": 3151
      },
      {
        "s": "I generally just buy wh",
        "t": 3313
      },
      {
        "s": "I generally just buy wha",
        "t": 3432
      },
      {
        "s": "I generally just buy what",
        "t": 3622
      },
      {
        "s": "I generally just buy whate",
        "t": 3890
      },
      {
        "s": "I generally just buy whatev",
        "t": 4064
      },
      {
        "s": "I generally just buy whateve",
        "t": 4216
      },
      {
        "s": "I generally just buy whatever",
        "t": 4341
      },
      {
        "s": "I generally just buy whatever'",
        "t": 4440
      },
      {
        "s": "I generally just buy whatever's",
        "t": 4666
      },
      {
        "s": "I generally just buy whatever's ",
        "t": 5026
      },
      {
        "s": "I generally just buy whatever's c",
        "t": 5166
      },
      {
        "s": "I generally just buy whatever's ch",
        "t": 5373
      },
      {
        "s": "I generally just buy whatever's che",
        "t": 5499
      },
      {
        "s": "I generally just buy whatever's chea",
        "t": 5598
      },
      {
        "s": "I generally just buy whatever's cheap",
        "t": 5677
      },
      {
        "s": "I generally just buy whatever's cheape",
        "t": 5766
      },
      {
        "s": "I generally just buy whatever's cheapes",
        "t": 5977
      },
      {
        "s": "I generally just buy whatever's cheapest",
        "t": 6105
      },
      {
        "s": "I generally just buy whatever's cheapest ",
        "t": 6252
      },
      {
        "s": "I generally just buy whatever's cheapest a",
        "t": 6353
      },
      {
        "s": "I generally just buy whatever's cheapest an",
        "t": 6531
      },
      {
        "s": "I generally just buy whatever's cheapest and",
        "t": 6578
      },
      {
        "s": "I generally just buy whatever's cheapest and ",
        "t": 6646
      },
      {
        "s": "I generally just buy whatever's cheapest and l",
        "t": 6860
      },
      {
        "s": "I generally just buy whatever's cheapest and lo",
        "t": 7019
      },
      {
        "s": "I generally just buy whatever's cheapest and loo",
        "t": 7152
      },
      {
        "s": "I generally just buy whatever's cheapest and look",
        "t": 7448
      },
      {
        "s": "I generally just buy whatever's cheapest and look ",
        "t": 7605
      },
      {
        "s": "I generally just buy whatever's cheapest and look f",
        "t": 7731
      },
      {
        "s": "I generally just buy whatever's cheapest and look fo",
        "t": 7780
      },
      {
        "s": "I generally just buy whatever's cheapest and look for",
        "t": 7966
      },
      {
        "s": "I generally just buy whatever's cheapest and look for ",
        "t": 8314
      },
      {
        "s": "I generally just buy whatever's cheapest and look for s",
        "t": 8468
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sa",
        "t": 8791
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sal",
        "t": 8900
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sale",
        "t": 9077
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales",
        "t": 9167
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales.",
        "t": 9256
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. ",
        "t": 9349
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. S",
        "t": 9412
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. So",
        "t": 9492
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Som",
        "t": 9637
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Some",
        "t": 9765
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Somet",
        "t": 9825
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Someti",
        "t": 9954
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometim",
        "t": 10034
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometime",
        "t": 10234
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes",
        "t": 10289
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes ",
        "t": 10498
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I",
        "t": 10653
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'",
        "t": 10753
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'l",
        "t": 10766
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll",
        "t": 10863
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll ",
        "t": 11014
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll b",
        "t": 11093
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll bu",
        "t": 11308
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy",
        "t": 11454
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy ",
        "t": 11591
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy i",
        "t": 11670
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in",
        "t": 11751
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in ",
        "t": 11910
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in b",
        "t": 12074
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bu",
        "t": 12154
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bul",
        "t": 12234
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk",
        "t": 12340
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk ",
        "t": 12453
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk i",
        "t": 12538
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if",
        "t": 12715
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if ",
        "t": 12871
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if t",
        "t": 12971
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if th",
        "t": 13532
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the",
        "t": 13702
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the ",
        "t": 13781
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the d",
        "t": 13815
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the de",
        "t": 13993
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the dea",
        "t": 14074
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal",
        "t": 14270
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal ",
        "t": 14350
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal i",
        "t": 14628
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is",
        "t": 14789
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is ",
        "t": 14872
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is e",
        "t": 14965
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is es",
        "t": 15041
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is esp",
        "t": 15141
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is espe",
        "t": 15233
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is espec",
        "t": 15317
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especi",
        "t": 15464
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especia",
        "t": 15526
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especial",
        "t": 15645
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especiall",
        "t": 15733
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially",
        "t": 15906
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially ",
        "t": 16153
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially g",
        "t": 16523
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially go",
        "t": 16694
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially goo",
        "t": 17436
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially good",
        "t": 17538
      },
      {
        "s": "I generally just buy whatever's cheapest and look for sales. Sometimes I'll buy in bulk if the deal is especially good.",
        "t": 17753
      }
    ]
  },
  "Gibberish Response": {
    "question": "What is your favorite cereal to eat for breakfast?",
    "response": "My mine a big yes and one times",
    "result": {
      "flagged": true,
      "flags": "Automated test: Gibberish",
      "effort_rating": 2,
    },
    "fingerprint_checks": {
      "ip":"10.0.15.164",
      "city":"Nairobi",
      "geolocation":{"latitude":-1.29111,"longitude":36.79247},
      "browser":"Chrome 128.1.0",
      "vpn":true,
      "incognito":false,
      "device_id":"5alsa3Tu8Ht6HY1Kh13p"
    },
    "questionHistory": [
      {
        "s": "M",
        "t": 17189974315101
      },
      {
        "s": "My",
        "t": 193
      },
      {
        "s": "My ",
        "t": 290
      },
      {
        "s": "My m",
        "t": 501
      },
      {
        "s": "My mi",
        "t": 650
      },
      {
        "s": "My min",
        "t": 737
      },
      {
        "s": "My mine",
        "t": 871
      },
      {
        "s": "My mine ",
        "t": 979
      },
      {
        "s": "My mine a",
        "t": 1160
      },
      {
        "s": "My mine a ",
        "t": 1273
      },
      {
        "s": "My mine a b",
        "t": 1461
      },
      {
        "s": "My mine a bi",
        "t": 1566
      },
      {
        "s": "My mine a big",
        "t": 1670
      },
      {
        "s": "My mine a big ",
        "t": 1777
      },
      {
        "s": "My mine a big y",
        "t": 1961
      },
      {
        "s": "My mine a big ye",
        "t": 2042
      },
      {
        "s": "My mine a big yes",
        "t": 2130
      },
      {
        "s": "My mine a big yes ",
        "t": 2257
      },
      {
        "s": "My mine a big yes a",
        "t": 2428
      },
      {
        "s": "My mine a big yes an",
        "t": 2486
      },
      {
        "s": "My mine a big yes and",
        "t": 2627
      },
      {
        "s": "My mine a big yes and ",
        "t": 2748
      },
      {
        "s": "My mine a big yes and o",
        "t": 2914
      },
      {
        "s": "My mine a big yes and on",
        "t": 2969
      },
      {
        "s": "My mine a big yes and one",
        "t": 3063
      },
      {
        "s": "My mine a big yes and one ",
        "t": 3342
      },
      {
        "s": "My mine a big yes and one t",
        "t": 3493
      },
      {
        "s": "My mine a big yes and one ti",
        "t": 3547
      },
      {
        "s": "My mine a big yes and one tim",
        "t": 3621
      },
      {
        "s": "My mine a big yes and one time",
        "t": 3713
      },
      {
        "s": "My mine a big yes and one times",
        "t": 3790
      }
    ]
  },
  "Low-Effort Response": {
    "question": "How would you describe the look and feel of the product?",
    "response": "idk",
    "result": {
      "flagged": true,
      "flags": "Low-effort",
      "effort_rating": 1,
    },
    "fingerprint_checks": {
      "ip":"172.16.89.230",
      "city":"Chattanooga",
      "geolocation":{"latitude":35.0474,"longitude":-85.3116},
      "browser":"Safari 18.0.1",
      "vpn":false,
      "incognito":true,
      "device_id":"ltAjMogBoJktGPHmGJPM"
    },
    "questionHistory": [
      {
        "s": "i",
        "t": 17189974315101
      },
      {
        "s": "d",
        "t": 200
      },
      {
        "s": "k",
        "t": 156
      }
    ]
  },
  "Off-Topic Response": {
    "question": "Why did you rate this car design as a 3?",
    "response": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fudge.",
    "result": {
      "flagged": true,
      "flags": "Automated test: Off-topic",
      "effort_rating": 4,
    },
    "fingerprint_checks": {
      "ip":"192.168.42.13",
      "city":"Bristol",
      "geolocation":{"latitude":51.4540,"longitude":-2.5879},
      "browser":"Firefox 129.1",
      "vpn":false,
      "incognito":false,
      "device_id":"KIeJ5kiPrRTZdIXUAd0H"
    },
    "questionHistory": [
      {
        "s": "I",
        "t": 17189974313475
      },
      {
        "s": "I ",
        "t": 103
      },
      {
        "s": "I p",
        "t": 236
      },
      {
        "s": "I pr",
        "t": 329
      },
      {
        "s": "I pre",
        "t": 418
      },
      {
        "s": "I pref",
        "t": 615
      },
      {
        "s": "I prefe",
        "t": 805
      },
      {
        "s": "I prefer",
        "t": 872
      },
      {
        "s": "I prefer ",
        "t": 1022
      },
      {
        "s": "I prefer c",
        "t": 1202
      },
      {
        "s": "I prefer ch",
        "t": 1335
      },
      {
        "s": "I prefer cho",
        "t": 1482
      },
      {
        "s": "I prefer choc",
        "t": 1588
      },
      {
        "s": "I prefer chocl",
        "t": 1804
      },
      {
        "s": "I prefer chocla",
        "t": 1964
      },
      {
        "s": "I prefer choclat",
        "t": 2074
      },
      {
        "s": "I prefer choclate",
        "t": 2154
      },
      {
        "s": "I prefer choclate ",
        "t": 2239
      },
      {
        "s": "I prefer choclate i",
        "t": 2427
      },
      {
        "s": "I prefer choclate ic",
        "t": 2547
      },
      {
        "s": "I prefer choclate ice",
        "t": 2718
      },
      {
        "s": "I prefer choclate ",
        "t": 3179
      },
      {
        "s": "I prefer ",
        "t": 3500
      },
      {
        "s": "I prefer c",
        "t": 3769
      },
      {
        "s": "I prefer ch",
        "t": 3891
      },
      {
        "s": "I prefer cho",
        "t": 4057
      },
      {
        "s": "I prefer choc",
        "t": 4181
      },
      {
        "s": "I prefer choco",
        "t": 4312
      },
      {
        "s": "I prefer chocol",
        "t": 4570
      },
      {
        "s": "I prefer chocola",
        "t": 4852
      },
      {
        "s": "I prefer chocolat",
        "t": 4938
      },
      {
        "s": "I prefer chocolate",
        "t": 5038
      },
      {
        "s": "I prefer chocolate ",
        "t": 5132
      },
      {
        "s": "I prefer chocolate i",
        "t": 5289
      },
      {
        "s": "I prefer chocolate ic",
        "t": 5411
      },
      {
        "s": "I prefer chocolate ice",
        "t": 5701
      },
      {
        "s": "I prefer chocolate ice ",
        "t": 6029
      },
      {
        "s": "I prefer chocolate ice c",
        "t": 6168
      },
      {
        "s": "I prefer chocolate ice cr",
        "t": 6391
      },
      {
        "s": "I prefer chocolate ice cre",
        "t": 6452
      },
      {
        "s": "I prefer chocolate ice crea",
        "t": 6541
      },
      {
        "s": "I prefer chocolate ice cream",
        "t": 6703
      },
      {
        "s": "I prefer chocolate ice cream ",
        "t": 6762
      },
      {
        "s": "I prefer chocolate ice cream o",
        "t": 7190
      },
      {
        "s": "I prefer chocolate ice cream ov",
        "t": 7277
      },
      {
        "s": "I prefer chocolate ice cream ove",
        "t": 7449
      },
      {
        "s": "I prefer chocolate ice cream over",
        "t": 7534
      },
      {
        "s": "I prefer chocolate ice cream over ",
        "t": 7574
      },
      {
        "s": "I prefer chocolate ice cream over v",
        "t": 7735
      },
      {
        "s": "I prefer chocolate ice cream over va",
        "t": 7837
      },
      {
        "s": "I prefer chocolate ice cream over van",
        "t": 8067
      },
      {
        "s": "I prefer chocolate ice cream over vani",
        "t": 8140
      },
      {
        "s": "I prefer chocolate ice cream over vanil",
        "t": 8351
      },
      {
        "s": "I prefer chocolate ice cream over vanill",
        "t": 8496
      },
      {
        "s": "I prefer chocolate ice cream over vanilla",
        "t": 8569
      },
      {
        "s": "I prefer chocolate ice cream over vanilla.",
        "t": 8788
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. ",
        "t": 9189
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. T",
        "t": 9599
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. ",
        "t": 9862
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. I",
        "t": 10040
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It",
        "t": 10186
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It ",
        "t": 10235
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It h",
        "t": 10357
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It ha",
        "t": 10387
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has",
        "t": 10458
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has ",
        "t": 10590
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a",
        "t": 10635
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a ",
        "t": 10762
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a r",
        "t": 10841
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a re",
        "t": 10917
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a r",
        "t": 11245
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a rc",
        "t": 11507
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a rci",
        "t": 11520
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a rcih",
        "t": 11746
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a rcihe",
        "t": 11784
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a rciher",
        "t": 11855
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a ",
        "t": 12167
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a r",
        "t": 12790
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a ri",
        "t": 12879
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a ric",
        "t": 12994
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a rich",
        "t": 13118
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a riche",
        "t": 13187
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer",
        "t": 13261
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer ",
        "t": 13365
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer f",
        "t": 14015
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer fa",
        "t": 14173
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer fal",
        "t": 14241
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer falv",
        "t": 14471
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer ",
        "t": 15237
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer f",
        "t": 15612
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer fl",
        "t": 15733
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer fla",
        "t": 15841
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flav",
        "t": 15890
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavo",
        "t": 16047
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor",
        "t": 16252
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor ",
        "t": 16377
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor a",
        "t": 16840
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor an",
        "t": 16921
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and",
        "t": 17003
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and ",
        "t": 17123
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and g",
        "t": 17278
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and go",
        "t": 17374
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goe",
        "t": 17444
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes",
        "t": 17529
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes ",
        "t": 17645
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes w",
        "t": 17788
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes we",
        "t": 17859
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes wel",
        "t": 17970
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well",
        "t": 18114
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well ",
        "t": 18206
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well w",
        "t": 18409
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well wi",
        "t": 18468
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well wit",
        "t": 18589
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with",
        "t": 18658
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with ",
        "t": 18741
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with t",
        "t": 18877
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with to",
        "t": 18974
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with top",
        "t": 19161
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with topp",
        "t": 19304
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppi",
        "t": 19479
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppin",
        "t": 19536
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with topping",
        "t": 19569
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings",
        "t": 19669
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings ",
        "t": 19780
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings a",
        "t": 19855
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings an",
        "t": 19962
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings and",
        "t": 20038
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings ",
        "t": 20415
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings l",
        "t": 20627
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings li",
        "t": 20785
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings lik",
        "t": 20932
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like",
        "t": 21003
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like ",
        "t": 21121
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like n",
        "t": 21295
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nu",
        "t": 21603
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nut",
        "t": 21684
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts",
        "t": 21862
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts ",
        "t": 21966
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts a",
        "t": 22041
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts an",
        "t": 22151
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and",
        "t": 22259
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and ",
        "t": 22346
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and d",
        "t": 22478
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and du",
        "t": 22611
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and dug",
        "t": 22678
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and duge",
        "t": 22790
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and duge.",
        "t": 23107
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and duge",
        "t": 23533
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and ",
        "t": 23900
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and f",
        "t": 24168
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fu",
        "t": 24458
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fug",
        "t": 24562
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fugd",
        "t": 24787
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fugdg",
        "t": 24977
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fugdge",
        "t": 25070
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fugdg",
        "t": 25551
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fugd",
        "t": 25734
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fug",
        "t": 25898
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fu",
        "t": 26077
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fud",
        "t": 26854
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fudg",
        "t": 27011
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fudge",
        "t": 27157
      },
      {
        "s": "I prefer chocolate ice cream over vanilla. It has a richer flavor and goes well with toppings like nuts and fudge.",
        "t": 27486
      }
    ]
  },
  "AI-Generated Response": {
    "question": "What do you feel is a good temperature for a room to be at?",
    "response": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or warmer.",
    "result": {
      "flagged": true,
      "flags": "Automated test: GPT; Unnatural typing",
      "effort_rating": 6,
    },
    "fingerprint_checks": {
      "ip":"10.10.255.187",
      "city":"Manila",
      "geolocation":{"latitude":14.62068,"longitude":120.9937},
      "browser":"Firefox 131.0",
      "vpn":true,
      "incognito":true,
      "device_id":"i5rHPXddZ0KIUAJRkITe"
    },
      "questionHistory": [
        {
          "s": "A",
          "t": 17189974905103
        },
        {
          "s": "A ",
          "t": 68
        },
        {
          "s": "A c",
          "t": 170
        },
        {
          "s": "A co",
          "t": 238
        },
        {
          "s": "A com",
          "t": 269
        },
        {
          "s": "A comf",
          "t": 300
        },
        {
          "s": "A comfo",
          "t": 331
        },
        {
          "s": "A comfor",
          "t": 433
        },
        {
          "s": "A comfort",
          "t": 535
        },
        {
          "s": "A comforta",
          "t": 603
        },
        {
          "s": "A comfortab",
          "t": 671
        },
        {
          "s": "A comfortabl",
          "t": 702
        },
        {
          "s": "A comfortable",
          "t": 770
        },
        {
          "s": "A comfortable ",
          "t": 872
        },
        {
          "s": "A comfortable r",
          "t": 903
        },
        {
          "s": "A comfortable ro",
          "t": 934
        },
        {
          "s": "A comfortable roo",
          "t": 965
        },
        {
          "s": "A comfortable room",
          "t": 1033
        },
        {
          "s": "A comfortable room ",
          "t": 1101
        },
        {
          "s": "A comfortable room t",
          "t": 1203
        },
        {
          "s": "A comfortable room te",
          "t": 1234
        },
        {
          "s": "A comfortable room tem",
          "t": 1336
        },
        {
          "s": "A comfortable room temp",
          "t": 1404
        },
        {
          "s": "A comfortable room tempe",
          "t": 1435
        },
        {
          "s": "A comfortable room temper",
          "t": 1503
        },
        {
          "s": "A comfortable room tempera",
          "t": 1571
        },
        {
          "s": "A comfortable room temperat",
          "t": 1602
        },
        {
          "s": "A comfortable room temperatu",
          "t": 1633
        },
        {
          "s": "A comfortable room temperatur",
          "t": 1701
        },
        {
          "s": "A comfortable room temperature",
          "t": 1769
        },
        {
          "s": "A comfortable room temperature ",
          "t": 1837
        },
        {
          "s": "A comfortable room temperature t",
          "t": 1939
        },
        {
          "s": "A comfortable room temperature ty",
          "t": 2041
        },
        {
          "s": "A comfortable room temperature typ",
          "t": 2072
        },
        {
          "s": "A comfortable room temperature typi",
          "t": 2103
        },
        {
          "s": "A comfortable room temperature typic",
          "t": 2205
        },
        {
          "s": "A comfortable room temperature typica",
          "t": 2273
        },
        {
          "s": "A comfortable room temperature typical",
          "t": 2304
        },
        {
          "s": "A comfortable room temperature typicall",
          "t": 2335
        },
        {
          "s": "A comfortable room temperature typically",
          "t": 2366
        },
        {
          "s": "A comfortable room temperature typically ",
          "t": 2397
        },
        {
          "s": "A comfortable room temperature typically r",
          "t": 2428
        },
        {
          "s": "A comfortable room temperature typically ra",
          "t": 2496
        },
        {
          "s": "A comfortable room temperature typically ran",
          "t": 2564
        },
        {
          "s": "A comfortable room temperature typically rang",
          "t": 2632
        },
        {
          "s": "A comfortable room temperature typically range",
          "t": 2734
        },
        {
          "s": "A comfortable room temperature typically ranges",
          "t": 2802
        },
        {
          "s": "A comfortable room temperature typically ranges ",
          "t": 2904
        },
        {
          "s": "A comfortable room temperature typically ranges b",
          "t": 2972
        },
        {
          "s": "A comfortable room temperature typically ranges be",
          "t": 3003
        },
        {
          "s": "A comfortable room temperature typically ranges bet",
          "t": 3071
        },
        {
          "s": "A comfortable room temperature typically ranges betw",
          "t": 3139
        },
        {
          "s": "A comfortable room temperature typically ranges betwe",
          "t": 3170
        },
        {
          "s": "A comfortable room temperature typically ranges betwee",
          "t": 3201
        },
        {
          "s": "A comfortable room temperature typically ranges between",
          "t": 3269
        },
        {
          "s": "A comfortable room temperature typically ranges between ",
          "t": 3300
        },
        {
          "s": "A comfortable room temperature typically ranges between 6",
          "t": 3368
        },
        {
          "s": "A comfortable room temperature typically ranges between 68",
          "t": 3436
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-",
          "t": 3467
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-7",
          "t": 3535
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72",
          "t": 3566
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°",
          "t": 3668
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F",
          "t": 3770
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F.",
          "t": 3801
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. ",
          "t": 3903
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. H",
          "t": 3971
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. Ho",
          "t": 4039
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. How",
          "t": 4070
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. Howe",
          "t": 4101
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. Howev",
          "t": 4203
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. Howeve",
          "t": 4305
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However",
          "t": 4373
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However,",
          "t": 4475
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, ",
          "t": 4577
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, p",
          "t": 4608
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, pe",
          "t": 4676
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, per",
          "t": 4707
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, pers",
          "t": 4738
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, perso",
          "t": 4769
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, person",
          "t": 4871
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, persona",
          "t": 4973
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal",
          "t": 5075
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal ",
          "t": 5143
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal p",
          "t": 5211
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal pr",
          "t": 5279
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal pre",
          "t": 5381
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal pref",
          "t": 5412
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal prefe",
          "t": 5514
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal prefer",
          "t": 5545
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal prefere",
          "t": 5613
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferen",
          "t": 5715
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferenc",
          "t": 5817
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preference",
          "t": 5885
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences",
          "t": 5987
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences ",
          "t": 6089
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences c",
          "t": 6157
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences ca",
          "t": 6225
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can",
          "t": 6327
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can ",
          "t": 6395
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can v",
          "t": 6426
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can va",
          "t": 6528
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can var",
          "t": 6596
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary",
          "t": 6664
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary.",
          "t": 6766
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary.",
          "t": 6797
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary.",
          "t": 6828
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. ",
          "t": 6859
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. S",
          "t": 6961
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. So",
          "t": 7029
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Som",
          "t": 7131
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some",
          "t": 7199
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some ",
          "t": 7230
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some p",
          "t": 7298
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some pe",
          "t": 7366
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some peo",
          "t": 7434
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some peop",
          "t": 7465
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some peopl",
          "t": 7496
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people",
          "t": 7564
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people ",
          "t": 7666
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people p",
          "t": 7697
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people pr",
          "t": 7765
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people pre",
          "t": 7833
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people pref",
          "t": 7901
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefe",
          "t": 8003
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer",
          "t": 8034
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer ",
          "t": 8102
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer i",
          "t": 8133
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it",
          "t": 8201
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it ",
          "t": 8269
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it s",
          "t": 8300
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it sl",
          "t": 8402
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it sli",
          "t": 8433
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slig",
          "t": 8464
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it sligh",
          "t": 8532
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slight",
          "t": 8634
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightl",
          "t": 8665
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly",
          "t": 8767
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly ",
          "t": 8835
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly c",
          "t": 8866
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly co",
          "t": 8897
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly coo",
          "t": 8965
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cool",
          "t": 9033
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly coole",
          "t": 9135
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler",
          "t": 9203
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler ",
          "t": 9234
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler o",
          "t": 9265
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or",
          "t": 9367
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or ",
          "t": 9469
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or w",
          "t": 9571
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or wa",
          "t": 9639
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or war",
          "t": 9670
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or warm",
          "t": 9701
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or warme",
          "t": 9769
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or warmer",
          "t": 9837
        },
        {
          "s": "A comfortable room temperature typically ranges between 68-72°F. However, personal preferences can vary. Some people prefer it slightly cooler or warmer.",
          "t": 9868
        }
      ]
    }
};